const currencyFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

export { formatEuro } from '#lib/numberFormat';

/**
 * Formats a numeric value as a currency string with decimals (e.g. "12.500,00 €").
 * Returns an empty string when the value is null or undefined.
 * @param {number|null|undefined} value - Value to format
 * @returns {string}
 */
export function formatPrice(value) {
	if (value === null) return '';
	return currencyFormatter.format(value);
}

/**
 * Formats an ISO date string using the German locale (e.g. "05. Mai 2026").
 * Returns the fallback string when the value is empty or invalid.
 * @param {string|null|undefined} iso - ISO date string
 * @param {string} [fallback='–'] - Fallback for an invalid date
 * @returns {string}
 */
export function formatDate(iso, fallback = '–') {
	if (!iso) return fallback;
	try {
		return new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: 'short', year: 'numeric' }).format(
			new Date(iso),
		);
	} catch {
		return fallback;
	}
}

/**
 * Builds the loss-reason label for a lost deal: the labelled category, followed
 * by its free-text note on a second line when one was given. A note without a
 * category still renders, since orgs may leave the loss reason optional. Returns
 * null when neither was recorded, so callers can skip rendering entirely.
 *
 * Mirrors the wording the backend stamps into the stage_change activity body,
 * so the same loss reads identically in a tooltip and in the timeline.
 *
 * @param {{lossReason?: string|null, lossReasonNote?: string|null}} deal - Deal row
 * @returns {string|null} Display text, or null when nothing was recorded
 */
export function formatLossReason(deal) {
	const lines = [];
	if (deal?.lossReason) lines.push(`Verlustgrund: ${deal.lossReason}`);
	if (deal?.lossReasonNote) lines.push(deal.lossReasonNote);
	return lines.length ? lines.join('\n') : null;
}
